module.exports = __webpack_public_path__ + "static/media/Sansa Stark 2.c0850586.jpg";